import {Component, OnInit} from '@angular/core';
import {BackendService} from '../backend.service';
import {Registration} from '../datamodel/registration';
import {Faculty} from '../datamodel/faculty';
import {LeftMenuService} from '../left-menu.service';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.css']
})
export class CalendarComponent implements OnInit {
  public registrations: Registration[];
  public openedRegistrationsByFaculties: Array<[Faculty, Registration[]]>;
  public closedRegistrationsByFaculties: Array<[Faculty, Registration[]]>;

  constructor(public backend: BackendService, public menu: LeftMenuService) {
  }

  ngOnInit() {
    this.backend.getRegistrations()
      .subscribe(registrations => {
        this.openedRegistrationsByFaculties = this.groupByFaculties(registrations.filter(r => r.isOpen()));
        this.closedRegistrationsByFaculties = this.groupByFaculties(registrations.filter(r => !r.isOpen()));
      });
    this.menu.addPath([]);
  }

  public groupByFaculties(registrations: Registration[]) {
    const result = new Map<string, [Faculty, Registration[]]>();
    registrations.forEach(reg => {
      if (!reg.faculty) { return; }
      if (!result.has(reg.faculty.id)) {
        result.set(reg.faculty.id, [reg.faculty, []]);
      }
      result.get(reg.faculty.id)[1].push(reg);
    });
    return Array.from(result.values()).sort(
      (fr1, fr2) => fr1[0].id.localeCompare(fr2[0].id)
    );
  }
}
